<template>
  <div>
    <world-nav/>
    <b-form-group id="name" label="名称">
      <b-form-input v-model="info.name" />
    </b-form-group>
    <b-form-group id="memo" label="説明">
      <remark-editor v-model="info.memo"
        :danger="1000" :warn="800" />
    </b-form-group>
    <b-form-group id="image" label="スタンプ画像">
      <b-form-select v-model="info.icon" 
        :options="[
          { text:'銅スタンプ', value:'./img/achievement/bronze.png' },
          { text:'銀スタンプ', value:'./img/achievement/silver.png' },
          { text:'金スタンプ', value:'./img/achievement/gold.png' },
        ]"/>
      <b-img :src="info.icon | coalesceImage" width="80px" height="100px" fluid />
    </b-form-group>
    <b-form-group id="entry-event" label="獲得条件">
      <b-form-select v-if="$store.state.Session.admin" 
        v-model="entryEvent.type"
        :options="[
          { text:'エリア訪問', value:'visit' },
          { text:'ステータス獲得', value:'status' },
          { text:'ワールドクリア', value:'world' },
        ]"
        @change="entryEvent.value = null"
      />
      <b-form-select v-else 
        v-model="entryEvent.type"
        :options="[
          { text:'エリア訪問', value:'visit' },
          { text:'ステータス獲得', value:'status' }
        ]"
        @change="entryEvent.value = null"
      />
      <b-card v-if="entryEvent.type == 'visit'">
        <b-form-group id="entry-event-value" label="エリア"
          label-cols="3"
          description="指定したエリアに到達した時に獲得します。">
          <b-form-select v-model="entryEvent.value" :options="areas" />
        </b-form-group>
      </b-card>
      <b-card v-else-if="entryEvent.type == 'status'">
        <b-form-group id="entry-event-status" label="ステータス">
          <b-input-group append="以上">
            <b-input-group-prepend>
              <b-input-group append="が">
                <b-form-input v-model="entryEvent.status" />
              </b-input-group>
            </b-input-group-prepend>
            <b-form-input v-model="entryEvent.value"
              type="number" min="0" max="99" number />
          </b-input-group>
        </b-form-group>
      </b-card>
      <b-card v-else-if="entryEvent.type == 'world'">
        <b-form-group id="entry-event-value" label="ワールドクリア"
          label-cols="3"
          description="指定したワールドのクリア条件を達成した時に獲得します。">
          <b-form-select v-model="entryEvent.value" :options="worldsSelect" />
        </b-form-group>
      </b-card>
    </b-form-group>
    <b-card v-if="$store.state.Session.admin"
      id="base-event" title="基本動作">
      <b-tabs>
        <b-tab title="獲得動作">
          <command-editor v-model="got"
            :command="gotCommand" class="prepare" />
        </b-tab>
      </b-tabs>
    </b-card>
    
    <div class="ctrl-bar">
      <b-button type="button" @click="$router.back()">戻る</b-button>
      <b-button variant="danger" @click="removeCard">
        <font-awesome-icon icon="times" class="icon fa-1x" />
        このスタンプを削除
      </b-button>
    </div>
  </div>
</template>

<script>
import { phina } from '@/canvas'
import WorldNav from '@/components/WorldNav'
// import ResponseMessage from '@/components/ResponseMessage'
// import CodeEditor from '@/components/CodeEditor'
import RemarkEditor from '@/components/RemarkEditor'
import { default as CommandEditor } from '@/components/CommandEditor'
import _ from 'lodash'
import mixinPlayer from './mixin-player'
import { areas, worlds } from './mixin-editor'
export default {
  filters: {
    coalesceImage (image) {
      return image || './img/card/front.png'
    }
  },
  components: {
    WorldNav,
    RemarkEditor,
    CommandEditor,
    // Digest
    // ResponseMessage,
    // CodeEditor
  },
  mixins: [mixinPlayer, areas, worlds],
  props: {
    value: Object,
  },
  computed: {
    card () { return this.innerValue.card[this.$route.params.index] },
    info () { return _.find(this.card, {'@method':'info'}).args },
    entryEvent () { return _.find(this.card, {'@method':'entry-event'}).args },
    got () { return _.find(this.card, {'@method':'get'}) },
    gotCommand () {
      return {
        code:[
        ],
        hook:[
          'account/privilege.increase-max-character',
        ]
      }
    },
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  methods: {
    preview (data) {
      this.$store.dispatch('getCodePreview', { 
          code: data,
          complement: 1
        })
        .then((response) => {
          this.$store.dispatch('setCode', response.code)

          // eslint-disable-next-line
          phina.global.app.pushScene(RequestScene({
            assets: response.assets,
            success: (_response, args)=>{
              this.$emit('changePlayer', 'l-player')
              args.$extend(response)
                .$extend({ store:this.$store, bg:'img/ui/bg.png' });
              return 'StoryScene'
            }
          }))
        })
    },
    removeCard () {
      this.innerValue.card.splice(this.$route.params.index, 1)
      this.$router.push('/achievement')
    }
  },
  mounted () {
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)      
    }
  }
}
</script>

<style lang="scss" scoped>
.prepare {
  width: 100%;
  height: 400px;
}
.event-ctrl-bar {
  display: flex;

  .digest {
    margin-left: 10px;
  }
}
.ctrl-bar {
  padding: 10px;

  display: flex;
  justify-content: space-between;
}
</style>
